import inputKey from './inputKey'
const httpApi = new Map(
  [
    [inputKey.playQQMusic, {
      firstHalf: "https://c.y.qq.com/soso/fcgi-bin/client_search_cp?ct=24&qqmusic_ver=1298&new_json=1&remoteplace=txt.yqq.top&searchid=9527&t=0&aggr=1&cr=1&catZhida=1&lossless=0&flag_qc=0&p=1&n=20&w="
      ,secondHalf: "&g_tk=5381&jsonpCallback=MusicJsonCallback9527&loginUin=0&hostUin=0&format=jsonp&inCharset=utf8&outCharset=utf-8&notice=0&platform=yqq&needNewCode=0"
      ,playFirstHalf: "http://y.qq.com/#type=index&mids="
      ,playSecondHalf: "&play=1&ADTAG=baiduald"
    }]
    ,[inputKey.baidu, {
      firstHalf: "https://www.baidu.com/s?word="
      ,secondHalf: ""
    }]
    ,[inputKey.ecosia, {
      firstHalf: "https://www.ecosia.org/search?q="
      ,secondHalf: ""
    }]
    ,[inputKey.google, {
      firstHalf: "https://www.google.com/search?q="
      ,secondHalf: ""
    }]
    ,[inputKey.yahoo, {
      firstHalf: "https://search.yahoo.com/search?p="
      ,secondHalf: ""
    }]
    ,[inputKey.bing, {
      firstHalf: "https://cn.bing.com/search?q="
      ,secondHalf: ""
    }]
    ,[inputKey.qihu, {
      firstHalf: "https://www.so.com/s?ie=utf-8&fr=none&src=360sou_newhome&q="
      ,secondHalf: ""
    }]
    ,[inputKey.sougou, {
      firstHalf: "https://www.sogou.com/web?query="
      ,secondHalf: ""
    }]
    ,[inputKey.soso, {
      firstHalf: "http://www.soso.com/tx?ie=utf8&pid=&query="
      ,secondHalf: ""
    }]
    ,[inputKey.youku, {
      firstHalf: "http://so.youku.com/search_video/q_"
      ,secondHalf: ""
    }]
    ,[inputKey.tudou, {
      firstHalf: "http://www.soku.com/nt/search/q_"
      ,secondHalf: ""
    }]
    ,[inputKey.qqVideo, {
      firstHalf: "https://v.qq.com/x/search/?q="
      ,secondHalf: ""
    }]
    ,[inputKey.iqiyi, {
      firstHalf: "https://so.iqiyi.com/so/q_"
      ,secondHalf: ""
    }]
    ,[inputKey.bilibili, {
      firstHalf: "https://search.bilibili.com/all?keyword="
      ,secondHalf: ""
    }]
    ,[inputKey.mgtv, {
      firstHalf: "https://so.mgtv.com/so/k-"
      ,secondHalf: ""
    }]
    ,[inputKey.sohutv, {
      firstHalf: "https://so.tv.sohu.com/mts?wd="
      ,secondHalf: ""
    }]
    ,[inputKey.le, {
      firstHalf: "http://so.le.com/s?wd="
      ,secondHalf: ""
    }]
    ,[inputKey.acfun, {
      firstHalf: "http://www.acfun.cn/search/?#query="
      ,secondHalf: ""
    }]
    ,[inputKey.nico, {
      firstHalf: "http://www.nicovideo.jp/?CrossSearch-input="
      ,secondHalf: ""
    }]
    ,[inputKey.youtube, {
      firstHalf: "https://www.youtube.com/results?search_query="
      ,secondHalf: ""
    }]
    ,[inputKey.qqmusic, {
      firstHalf: "https://y.qq.com/portal/search.html#page=1&searchid=1&remoteplace=txt.yqq.top&t=song&w="
      ,secondHalf: ""
    }]
    ,[inputKey.xiamimusic, {
      firstHalf: "https://www.xiami.com/search?key="
      ,secondHalf: "&pos=1"
    }]
    ,[inputKey.netmusic, {
      firstHalf: "https://music.163.com/#/search/m/?s="
      ,secondHalf: ""
    }]
    ,[inputKey.kugoumusic, {
      firstHalf: "http://www.kugou.com/yy/html/search.html#searchType=song&searchKeyWord="
      ,secondHalf: ""
    }]
    ,[inputKey.youtubemusic, {
      firstHalf: "https://music.youtube.com/search?q="
      ,secondHalf: ""
    }]
    ,[inputKey.baidumusic, {
      firstHalf: "http://music.taihe.com/search?key="
      ,secondHalf: ""
    }]
    ,[inputKey.yinyuetai, {
      firstHalf: "http://so.yinyuetai.com/?keyword="
      ,secondHalf: ""
    }]
    ,[inputKey.qqmusicmv, {
      firstHalf: "https://y.qq.com/portal/search.html#page=1&searchid=1&remoteplace=txt.yqq.top&t=mv&w="
      ,secondHalf: ""
    }]
    ,[inputKey.zhihu, {
      firstHalf: "https://www.zhihu.com/search?type=content&q="
      ,secondHalf: ""
    }]
    ,[inputKey.baiduzhidao, {
      firstHalf: "https://zhidao.baidu.com/search?lm=0&rn=10&pn=0&fr=search&ie=gbk&word="
      ,secondHalf: ""
    }]
    ,[inputKey.baidubaikeSearch, {
      firstHalf: "https://baike.baidu.com/search/none?word="
      ,secondHalf: "&pn=0&rn=10&enc=utf8"
    }]
    ,[inputKey.baidubaike, {
      firstHalf: "https://baike.baidu.com/item/"
      ,secondHalf: ""
    }]
    ,[inputKey.sougoubaike, {
      firstHalf: "https://baike.sogou.com/Search.e?sp=S"
      ,secondHalf: ""
    }]
    ,[inputKey.qihubaike, {
      firstHalf: "https://baike.so.com/search/?q="
      ,secondHalf: ""
    }]
    ,[inputKey.hudongbaike, {
      firstHalf: "http://www.baike.com/wiki/"
      ,secondHalf: ""
    }]
    ,[inputKey.wikibaike, {
      firstHalf: "https://zh.wikipedia.org/wiki/"
      ,secondHalf: ""
    }]
    ,[inputKey.baiduxinwen, {
      firstHalf: "http://news.baidu.com/ns?tn=news&cl=2&rn=20&ct=1&fr=bks0000&ie=utf-8&word="
      ,secondHalf: ""
    }]
    ,[inputKey.qqxinwen, {
      firstHalf: "https://www.sogou.com/sogou?site=news.qq.com&query="
      ,secondHalf: ""
    }]
    ,[inputKey.sohuxinwen, {
      firstHalf: "http://news.sogou.com/news?ie=utf8&p=40230447&interV=kKIOkrELjboLmLkElbYTkKIKmbELjboJmLkEkL8TkKIRmLkEk78TkKILkY==_-1091100819&query="
      ,secondHalf: ""
    }]
    ,[inputKey.sinaxinwen, {
      firstHalf: "http://search.sina.com.cn/?q="
      ,secondHalf: "&range=all&c=news&sort=time"
    }]
    ,[inputKey.taobao, {
      firstHalf: "https://s.taobao.com/search?q="
      ,secondHalf: ""
    }]
    ,[inputKey.tmall, {
      firstHalf: "https://list.tmall.com/search_product.htm?q="
      ,secondHalf: ""
    }]
    ,[inputKey.jd, {
      firstHalf: "https://search.jd.com/Search?keyword="
      ,secondHalf: "&enc=utf-8"
    }]
    ,[inputKey.amazon, {
      firstHalf: "https://www.amazon.com/s/ref=nb_sb_noss_2?url=search-alias%3Daps&field-keywords="
      ,secondHalf: ""
    }]
    ,[inputKey.amazoncn, {
      firstHalf: "https://www.amazon.cn/s/ref=nb_sb_noss_2?__mk_zh_CN=%E4%BA%9A%E9%A9%AC%E9%80%8A%E7%BD%91%E7%AB%99&url=search-alias%3Daps&field-keywords="
      ,secondHalf: ""
    }]
    ,[inputKey.github, {
      firstHalf: "https://github.com/search?q="
      ,secondHalf: ""
    }]
    ,[inputKey.oschina, {
      firstHalf: "https://www.oschina.net/search?scope=project&q="
      ,secondHalf: ""
    }]
    ,[inputKey.segmentfault, {
      firstHalf: "https://segmentfault.com/search?q="
      ,secondHalf: ""
    }]
    ,[inputKey.stackoverflow, {
      firstHalf: "https://stackoverflow.com/search?q="
      ,secondHalf: ""
    }]
    ,[inputKey.playQQMusicMv, {
      firstHalf: "https://c.y.qq.com/soso/fcgi-bin/client_search_cp?ct=24&qqmusic_ver=1298&new_json=1&remoteplace=txt.yqq.top&searchid=9527&t=0&aggr=1&cr=1&catZhida=1&lossless=0&flag_qc=0&p=1&n=20&w="
      ,secondHalf: "&g_tk=5381&jsonpCallback=MusicJsonCallback9527&loginUin=0&hostUin=0&format=jsonp&inCharset=utf8&outCharset=utf-8&notice=0&platform=yqq&needNewCode=0"
      ,playFirstHalf: "https://y.qq.com/n/yqq/mv/v/"
      ,playSecondHalf: ".html"
    }]
  ]
)
export default httpApi



// WEBPACK FOOTER //
// ./src/cnConst/httpApi.js